export const REMIND_MAIL_SUBJECT = '発注状況リマインド'; // リマインドメールの件名
export const REMIND_MAIL_FORM = `※本メールは自動送信です。This is an automated message.

English follows Japanese

仕入先へ発送状況のご確認をお願いします。Please confirm the shipping status to the supplier.

LEAN PATH Inc.`; // リマインドメールのフォームテキスト
export const REMIND_MAIL_JAPANESE_ORDER_LABEL = '\n発注数量 / 希望納期 / 置場名 / 仕入先名 / 商品CD / 商品名 / 容量'; // リマインドメールに記載する発注情報用のラベル（日本語）
export const REMIND_MAIL_ENGLISH_ORDER_LABEL = `\nOrder Qty / RETA / Storage location name / Supplier name / Material code / Material name / Packing unit`; // リマインドメールに記載する発注情報用のラベル（英語）
export const REMIND_MAIL_SENDER_ADDRESS = 'order_remind@lean-path.com'; // リマインドメールの送信元アドレス
